const PREFIX = "REPORTS";

export class GET_REPORTS_LOV {
  public static readonly type = `[${PREFIX} GET REPORTS LOV]`;
  constructor(public readonly payload) {}
}

export class GET_REPORTS_BDM_AGENT {
  public static readonly type = `[${PREFIX} GET REPORTS BDM AGENT]`;
  constructor(public readonly payload) {}
}

export class GET_REPORTS_BRANCH_AGENT {
  public static readonly type = `[${PREFIX} GET REPORTS BRANCH AGENT]`;
  constructor(public readonly payload) {}
}

export class GET_CAMPAIGN_REPORT {
  public static readonly type = `[${PREFIX}] GET CAMPAIGN REPORTS`;
  constructor(public readonly payload) {}
}

export class GET_PERFORMANCE_REPORT {
  public static readonly type = `[${PREFIX}] GET PERFORMANCE REPORTS`;
  constructor(public readonly payload) {}
}

export class DOWNLOAD_PERFORMANCE_REPORT {
  public static readonly type = `[${PREFIX}] DOWNLOAD PERFORMANCE REPORT`;
  constructor(public readonly payload) {}
}
export class GET_REPORT_YEAR {
  public static readonly type = `[${PREFIX}] GET REPORT YEAR`;
  constructor(public readonly payload) {}
}
